<div class="up-modal">
  <div class="left">
    <div class="column">
      <app-info-oc-or-nfe label="Nº da Ordem" [value]="data.orderNumber"></app-info-oc-or-nfe>
      <app-info-oc-or-nfe label="Data/Hora de Emissão" [value]="timestampToDate(data?.issuedAt)"></app-info-oc-or-nfe>
      <app-info-oc-or-nfe label="Tipo de entrada" [value]="translateEntrySource(data?.entrySource)"></app-info-oc-or-nfe>
    </div>
    <div class="column two">
      <app-info-oc-or-nfe label="Razão Social" [value]="'---'"></app-info-oc-or-nfe>
      <app-info-oc-or-nfe label="Endereço" [value]="'---'"></app-info-oc-or-nfe>
      <app-info-oc-or-nfe label="CPF/CNPJ Fornecedor" [value]="'---'"></app-info-oc-or-nfe>
    </div>
  </div>

  <div class="right">
    <app-provider-contact [provider]="{name: '---', phone: '---', email: '---'}"></app-provider-contact>
  </div>
</div>

<div class="down-modal">
  <app-product-list [products]="data?.manifest" [displayMode]="'table'"></app-product-list>
</div>